import type { TemplateTheme } from '@/types/template';

export const TEMPLATE_THEMES: Record<string, TemplateTheme> = {
    issue_impact_yellow: {
        id: 'issue_impact_yellow',
        name: '유튜브 임팩트 (옐로우)',
        category: 'dark',
        colors: {
            primary: '#faff00',
            text: '#ffffff',
            title1: '#faff00',
            title1Bg: '#000000',
            title2: '#000000',
            title2Bg: '#faff00',
            textBg: 'rgba(0, 0, 0, 0.95)',
            background: '#0a0a0a'
        },
        fonts: {
            title: { family: 'Jua', weight: 'normal', size: 80 },
            caption: { family: 'Noto Sans KR', weight: 'bold', size: 70 }
        }
    },
    issue_luxury_gold: {
        id: 'issue_luxury_gold',
        name: '럭셔리 미드나잇 (골드)',
        category: 'professional',
        colors: {
            primary: '#d4af37',
            text: '#ffffff',
            title1: '#d4af37',
            title1Bg: '#0f0f0f',
            title2: '#000000',
            title2Bg: '#d4af37',
            textBg: 'rgba(20, 20, 20, 0.98)',
            background: '#050505'
        },
        fonts: {
            title: { family: 'Nanum Myeongjo', weight: 'bold', size: 80 },
            title2: { family: 'Nanum Myeongjo', weight: 'normal', size: 80 },
            caption: { family: 'Noto Sans KR', weight: 'medium', size: 65 }
        }
    },
    issue_breaking_red: {
        id: 'issue_breaking_red',
        name: '속보 뉴스 (레드)',
        category: 'vibrant',
        colors: {
            primary: '#dc2626',
            text: '#ffffff',
            title1: '#ffffff',
            title1Bg: '#dc2626',
            title2: '#ffffff',
            title2Bg: '#000000',
            textBg: 'rgba(220, 38, 38, 0.95)',
            background: '#0a0a0a',
            accent: '#ef4444'
        },
        fonts: {
            title: { family: 'Noto Sans KR', weight: '900', size: 80 },
            caption: { family: 'Noto Sans KR', weight: 'bold', size: 70 }
        }
    },
    issue_cyber_neon: {
        id: 'issue_cyber_neon',
        name: '사이버 네온 (시안)',
        category: 'dark',
        colors: {
            primary: '#00f2ff',
            text: '#ffffff',
            title1: '#00f2ff',
            title1Bg: '#000000',
            title2: '#000000',
            title2Bg: '#00f2ff',
            textBg: 'rgba(0, 0, 0, 0.85)',
            background: '#000000'
        },
        fonts: {
            title: { family: 'Noto Sans KR', weight: 'black', size: 80 },
            caption: { family: 'Noto Sans KR', weight: 'bold', size: 70 }
        }
    },
    issue_vivid_orange: {
        id: 'issue_vivid_orange',
        name: '비비드 오렌지 (블랙)',
        category: 'vibrant',
        colors: {
            primary: '#ea580c',
            text: '#ffffff',
            title1: '#ffffff',
            title1Bg: '#ea580c',
            title2: '#000000',
            title2Bg: '#fef08a',
            textBg: 'rgba(234, 88, 12, 0.95)',
            background: '#0a0a0a'
        },
        fonts: {
            title: { family: 'Do Hyeon', weight: 'normal', size: 80 },
            caption: { family: 'Noto Sans KR', weight: 'black', size: 75 }
        }
    },
    issue_toxic_green: {
        id: 'issue_toxic_green',
        name: '톡식 그린 (임팩트)',
        category: 'dark',
        colors: {
            primary: '#84cc16',
            text: '#ffffff',
            title1: '#84cc16',
            title1Bg: '#000000',
            title2: '#000000',
            title2Bg: '#84cc16',
            textBg: 'rgba(0, 0, 0, 0.95)',
            background: '#0a0a0a'
        },
        fonts: {
            title: { family: 'Jua', weight: 'normal', size: 80 },
            caption: { family: 'Noto Sans KR', weight: 'bold', size: 70 }
        }
    },
    issue_deep_purple: {
        id: 'issue_deep_purple',
        name: '딥 퍼플 (미스터리)',
        category: 'dark',
        colors: {
            primary: '#a855f7',
            text: '#ffffff',
            title1: '#ffffff',
            title1Bg: '#7e22ce',
            title2: '#ffffff',
            title2Bg: '#000000',
            textBg: 'rgba(126, 34, 206, 0.95)',
            background: '#000000'
        },
        fonts: {
            title: { family: 'Gothic A1', weight: '900', size: 80 },
            caption: { family: 'Noto Sans KR', weight: 'bold', size: 70 }
        }
    },
    issue_sweet_pink: {
        id: 'issue_sweet_pink',
        name: '핫 핑크 (트렌디)',
        category: 'vibrant',
        colors: {
            primary: '#db2777',
            text: '#ffffff',
            title1: '#ffffff',
            title1Bg: '#db2777',
            title2: '#000000',
            title2Bg: '#fbcfe8',
            textBg: 'rgba(219, 39, 119, 0.95)',
            background: '#0a0a0a'
        },
        fonts: {
            title: { family: 'Jua', weight: 'normal', size: 80 },
            caption: { family: 'Jua', weight: 'normal', size: 75 }
        }
    },
    issue_ice_blue: {
        id: 'issue_ice_blue',
        name: '아이스 블루 (스마트)',
        category: 'professional',
        colors: {
            primary: '#38bdf8',
            text: '#ffffff',
            title1: '#38bdf8',
            title1Bg: '#000000',
            title2: '#000000',
            title2Bg: '#38bdf8',
            textBg: 'rgba(0, 0, 0, 0.95)',
            background: '#0a0a0a'
        },
        fonts: {
            title: { family: 'Noto Sans KR', weight: 'black', size: 80 },
            caption: { family: 'Noto Sans KR', weight: 'bold', size: 70 }
        }
    },
    issue_pure_white: {
        id: 'issue_pure_white',
        name: '퓨어 화이트 (모던)',
        category: 'minimal',
        colors: {
            primary: '#ffffff',
            text: '#ffffff',
            title1: '#ffffff',
            title1Bg: '#000000',
            title2: '#000000',
            title2Bg: '#ffffff',
            textBg: 'rgba(0, 0, 0, 0.95)',
            background: '#000000'
        },
        fonts: {
            title: { family: 'Noto Sans KR', weight: '900', size: 80 },
            caption: { family: 'Noto Sans KR', weight: 'bold', size: 70 }
        }
    },
    issue_cherry_blossom: {
        id: 'issue_cherry_blossom',
        name: '체리 블라썸 (화사함)',
        category: 'vibrant',
        colors: {
            primary: '#f472b6',
            text: '#ffffff',
            title1: '#f472b6',
            title1Bg: '#000000',
            title2: '#000000',
            title2Bg: '#f472b6',
            textBg: 'rgba(0, 0, 0, 0.95)',
            background: '#0a0a0a'
        },
        fonts: {
            title: { family: 'Do Hyeon', weight: 'normal', size: 80 },
            caption: { family: 'Noto Sans KR', weight: 'bold', size: 75 }
        }
    },
    issue_neon_green: {
        id: 'issue_neon_green',
        name: '네온 그린 (스포티)',
        category: 'dark',
        colors: {
            primary: '#22c55e',
            text: '#ffffff',
            title1: '#22c55e',
            title1Bg: '#000000',
            title2: '#000000',
            title2Bg: '#22c55e',
            textBg: 'rgba(0, 0, 0, 0.95)',
            background: '#0a0a0a'
        },
        fonts: {
            title: { family: 'Jua', weight: 'normal', size: 80 },
            caption: { family: 'Noto Sans KR', weight: 'bold', size: 70 }
        }
    },
    issue_golden_hour: {
        id: 'issue_golden_hour',
        name: '골든 아워 (따뜻한)',
        category: 'professional',
        colors: {
            primary: '#fbbf24',
            text: '#ffffff',
            title1: '#ffffff',
            title1Bg: '#b45309',
            title2: '#000000',
            title2Bg: '#fbbf24',
            textBg: 'rgba(180, 83, 9, 0.9)',
            background: '#0a0a0a'
        },
        fonts: {
            title: { family: 'Nanum Myeongjo', weight: 'bold', size: 80 },
            caption: { family: 'Noto Sans KR', weight: 'medium', size: 65 }
        }
    },
    issue_electric_blue: {
        id: 'issue_electric_blue',
        name: '일렉트릭 블루 (IT/테크)',
        category: 'modern',
        colors: {
            primary: '#3b82f6',
            text: '#ffffff',
            title1: '#ffffff',
            title1Bg: '#3b82f6',
            title2: '#3b82f6',
            title2Bg: '#000000',
            textBg: 'rgba(59, 130, 246, 0.9)',
            background: '#0a0a0a'
        },
        fonts: {
            title: { family: 'Gothic A1', weight: '900', size: 80 },
            caption: { family: 'Gothic A1', weight: 'bold', size: 70 }
        }
    },
    issue_blood_orange: {
        id: 'issue_blood_orange',
        name: '블러드 오렌지 (경고)',
        category: 'vibrant',
        colors: {
            primary: '#ef4444',
            text: '#ffffff',
            title1: '#ffffff',
            title1Bg: '#000000',
            title2: '#ffffff',
            title2Bg: '#ef4444',
            textBg: 'rgba(0, 0, 0, 0.9)',
            background: '#000000'
        },
        fonts: {
            title: { family: 'Jua', weight: 'normal', size: 80 },
            caption: { family: 'Noto Sans KR', weight: 'black', size: 70 }
        }
    },
    issue_mint_chocolate: {
        id: 'issue_mint_chocolate',
        name: '민트 초코 (산뜻함)',
        category: 'pastel',
        colors: {
            primary: '#34d399',
            text: '#ffffff',
            title1: '#34d399',
            title1Bg: '#1c1917',
            title2: '#1c1917',
            title2Bg: '#34d399',
            textBg: 'rgba(28, 25, 23, 0.95)',
            background: '#0a0a0a'
        },
        fonts: {
            title: { family: 'Do Hyeon', weight: 'normal', size: 80 },
            caption: { family: 'Do Hyeon', weight: 'normal', size: 75 }
        }
    },
    issue_mustard_black: {
        id: 'issue_mustard_black',
        name: '머스터드 블랙 (경쾌함)',
        category: 'minimal',
        colors: {
            primary: '#eab308',
            text: '#ffffff',
            title1: '#000000',
            title1Bg: '#eab308',
            title2: '#eab308',
            title2Bg: '#000000',
            textBg: 'rgba(234, 179, 8, 0.9)',
            background: '#000000'
        },
        fonts: {
            title: { family: 'Jua', weight: 'normal', size: 115 },
            caption: { family: 'Noto Sans KR', weight: 'bold', size: 70 }
        }
    },
    issue_royal_purple: {
        id: 'issue_royal_purple',
        name: '로열 퍼플 (고급)',
        category: 'professional',
        colors: {
            primary: '#6b21a8',
            text: '#ffffff',
            title1: '#fde047',
            title1Bg: '#6b21a8',
            title2: '#6b21a8',
            title2Bg: '#fde047',
            textBg: 'rgba(0, 0, 0, 0.9)',
            background: '#0a0a0a'
        },
        fonts: {
            title: { family: 'Nanum Myeongjo', weight: 'bold', size: 80 },
            caption: { family: 'Noto Sans KR', weight: 'medium', size: 65 }
        }
    },
    issue_coral_reef: {
        id: 'issue_coral_reef',
        name: '코랄 리프 (감각적)',
        category: 'pastel',
        colors: {
            primary: '#f43f5e',
            text: '#ffffff',
            title1: '#ffffff',
            title1Bg: '#f43f5e',
            title2: '#f43f5e',
            title2Bg: '#ffffff',
            textBg: 'rgba(244, 63, 94, 0.9)',
            background: '#0a0a0a'
        },
        fonts: {
            title: { family: 'Noto Sans KR', weight: '900', size: 80 },
            caption: { family: 'Noto Sans KR', weight: 'bold', size: 70 }
        }
    },
    issue_cyber_yellow: {
        id: 'issue_cyber_yellow',
        name: '사이버 옐로우 (경고)',
        category: 'dark',
        colors: {
            primary: '#fbbf24',
            text: '#000000',
            title1: '#000000',
            title1Bg: '#fbbf24',
            title2: '#fbbf24',
            title2Bg: '#000000',
            textBg: 'rgba(251, 191, 36, 0.9)',
            background: '#000000'
        },
        fonts: {
            title: { family: 'Jua', weight: 'normal', size: 80 },
            caption: { family: 'Noto Sans KR', weight: 'black', size: 75 }
        }
    },
    ssul_classic: {
        id: 'ssul_classic',
        name: '썰 클래식 (전용)',
        category: 'modern',
        colors: {
            primary: '#000000',
            text: '#000000',
            title1: '#000000',
            title2: '#000000',
            textBg: 'rgba(255, 255, 255, 0.9)',
            background: '#ffffff'
        },
        fonts: {
            title: { family: 'Jua', weight: 'normal', size: 80 },
            caption: { family: 'Jua', weight: 'normal', size: 65 }
        },
        backgroundImage: 'https://pub-a4dfdcfb43c74fae8d58f5cf840de43e.r2.dev/ssul_bg.png'
    },
    ssul_1: {
        id: 'ssul_1',
        name: '썰 테마 01 (기본)',
        category: 'modern',
        colors: {
            primary: '#000000',
            text: '#000000',
            title1: '#000000',
            title2: '#000000',
            textBg: 'rgba(255, 255, 255, 0.9)',
            background: '#ffffff'
        },
        fonts: {
            title: { family: 'Jua', weight: 'normal', size: 80 },
            caption: { family: 'Jua', weight: 'normal', size: 65 }
        },
        backgroundImage: 'https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/ssul/1.png'
    },
    ssul_2: {
        id: 'ssul_2',
        name: '썰 테마 02 (임팩트)',
        category: 'dark',
        colors: {
            primary: '#1a1a1a',
            text: '#000000',
            title1: '#000000',
            title2: '#000000',
            textBg: 'rgba(255, 255, 255, 0.9)',
            background: '#ffffff'
        },
        fonts: {
            title: { family: 'Do Hyeon', weight: 'normal', size: 80 },
            caption: { family: 'Do Hyeon', weight: 'normal', size: 65 }
        },
        backgroundImage: 'https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/ssul/2.png'
    },
    ssul_3: {
        id: 'ssul_3',
        name: '썰 테마 03 (감성)',
        category: 'pastel',
        colors: {
            primary: '#451a03',
            text: '#000000',
            title1: '#000000',
            title2: '#000000',
            textBg: 'rgba(255, 255, 255, 0.95)',
            background: '#fffbeb'
        },
        fonts: {
            title: { family: 'Poor Story', weight: 'normal', size: 80 },
            caption: { family: 'Poor Story', weight: 'normal', size: 70 }
        },
        backgroundImage: 'https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/ssul/3.png'
    },
    ssul_4: {
        id: 'ssul_4',
        name: '썰 테마 04 (모던)',
        category: 'minimal',
        colors: {
            primary: '#1f2937',
            text: '#000000',
            title1: '#000000',
            title2: '#000000',
            textBg: 'rgba(255, 255, 255, 0.9)',
            background: '#ffffff'
        },
        fonts: {
            title: { family: 'Gowun Dodum', weight: 'normal', size: 80 },
            caption: { family: 'Gowun Dodum', weight: 'normal', size: 65 }
        },
        backgroundImage: 'https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/ssul/4.png'
    },
    ssul_5: {
        id: 'ssul_5',
        name: '썰 테마 05',
        category: 'modern',
        colors: {
            primary: '#000000',
            text: '#000000',
            title1: '#000000',
            title2: '#000000',
            textBg: 'rgba(255, 255, 255, 0.9)',
            background: '#ffffff'
        },
        fonts: {
            title: { family: 'Nanum Gothic', weight: 'bold', size: 80 },
            caption: { family: 'Nanum Gothic', weight: 'normal', size: 65 }
        },
        backgroundImage: 'https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/ssul/5.png'
    },
    ssul_6: {
        id: 'ssul_6',
        name: '썰 테마 06',
        category: 'dark',
        colors: {
            primary: '#111827',
            text: '#000000',
            title1: '#000000',
            title2: '#000000',
            textBg: 'rgba(255, 255, 255, 0.85)',
            background: '#ffffff'
        },
        fonts: {
            title: { family: 'Jua', weight: 'normal', size: 80 },
            caption: { family: 'Jua', weight: 'normal', size: 65 }
        },
        backgroundImage: 'https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/ssul/6.png'
    },
    ssul_7: {
        id: 'ssul_7',
        name: '썰 테마 07',
        category: 'pastel',
        colors: {
            primary: '#166534',
            text: '#000000',
            title1: '#000000',
            title2: '#000000',
            textBg: 'rgba(255, 255, 255, 0.9)',
            background: '#f0fdf4'
        },
        fonts: {
            title: { family: 'Gamja Flower', weight: 'normal', size: 80 },
            caption: { family: 'Gamja Flower', weight: 'normal', size: 70 }
        },
        backgroundImage: 'https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/ssul/7.png'
    },
    ssul_8: {
        id: 'ssul_8',
        name: '썰 테마 08',
        category: 'professional',
        colors: {
            primary: '#1e3a8a',
            text: '#000000',
            title1: '#000000',
            title2: '#000000',
            textBg: 'rgba(255, 255, 255, 0.95)',
            background: '#ffffff'
        },
        fonts: {
            title: { family: 'Noto Sans KR', weight: 'bold', size: 80 },
            caption: { family: 'Noto Sans KR', weight: 'normal', size: 60 }
        },
        backgroundImage: 'https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/ssul/8.png'
    },
    ssul_9: {
        id: 'ssul_9',
        name: '썰 테마 09',
        category: 'vibrant',
        colors: {
            primary: '#9d174d',
            text: '#000000',
            title1: '#000000',
            title2: '#000000',
            textBg: 'rgba(255, 255, 255, 0.9)',
            background: '#fdf2f8'
        },
        fonts: {
            title: { family: 'Jua', weight: 'normal', size: 80 },
            caption: { family: 'Jua', weight: 'normal', size: 65 }
        },
        backgroundImage: 'https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/ssul/9.png'
    },
    ssul_10: {
        id: 'ssul_10',
        name: '썰 테마 10',
        category: 'dark',
        colors: {
            primary: '#78350f',
            text: '#000000',
            title1: '#000000',
            title2: '#000000',
            textBg: 'rgba(255, 255, 255, 0.9)',
            background: '#ffffff'
        },
        fonts: {
            title: { family: 'Jua', weight: 'normal', size: 80 },
            caption: { family: 'Jua', weight: 'normal', size: 65 }
        },
        backgroundImage: 'https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/ssul/10.png'
    },
    ssul_11: {
        id: 'ssul_11',
        name: '썰 테마 11',
        category: 'modern',
        colors: {
            primary: '#000000',
            text: '#000000',
            title1: '#ffffff',
            title2: '#000000',
            textBg: 'rgba(255, 255, 255, 0.85)',
            background: '#ffffff'
        },
        fonts: {
            title: { family: 'Nanum Gothic', weight: 'bold', size: 80 },
            caption: { family: 'Nanum Gothic', weight: 'normal', size: 65 }
        },
        backgroundImage: 'https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/ssul/11.png'
    },
    ssul_12: {
        id: 'ssul_12',
        name: '썰 테마 12',
        category: 'pastel',
        colors: {
            primary: '#5b21b6',
            text: '#000000',
            title1: '#ffffff',
            title2: '#000000',
            textBg: 'rgba(255, 255, 255, 0.9)',
            background: '#f5f3ff'
        },
        fonts: {
            title: { family: 'Poor Story', weight: 'normal', size: 80 },
            caption: { family: 'Poor Story', weight: 'normal', size: 70 }
        },
        backgroundImage: 'https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/ssul/12.png'
    },
    ssul_13: {
        id: 'ssul_13',
        name: '썰 테마 13',
        category: 'dark',
        colors: {
            primary: '#134e4a',
            text: '#000000',
            title1: '#ffffff',
            title2: '#000000',
            title1Bg: 'transparent',
            title2Bg: 'transparent',
            textBg: 'rgba(255, 255, 255, 0.9)',
            background: '#ffffff'
        },
        fonts: {
            title: { family: 'Do Hyeon', weight: 'normal', size: 80 },
            caption: { family: 'Do Hyeon', weight: 'normal', size: 65 }
        },
        backgroundImage: 'https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/ssul/13.png'
    },
    ssul_14: {
        id: 'ssul_14',
        name: '썰 테마 14',
        category: 'minimal',
        colors: {
            primary: '#374151',
            text: '#000000',
            title1: '#ffffff',
            title2: '#000000',
            title1Bg: 'transparent',
            title2Bg: 'transparent',
            textBg: 'rgba(255, 255, 255, 0.9)',
            background: '#ffffff'
        },
        fonts: {
            title: { family: 'Gowun Dodum', weight: 'normal', size: 80 },
            caption: { family: 'Gowun Dodum', weight: 'normal', size: 65 }
        },
        backgroundImage: 'https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/ssul/14.png'
    },
    ssul_15: {
        id: 'ssul_15',
        name: '썰 테마 15',
        category: 'modern',
        colors: {
            primary: '#000000',
            text: '#000000',
            title1: '#ffffff',
            title2: '#000000',
            title1Bg: 'transparent',
            title2Bg: 'transparent',
            textBg: 'rgba(249, 250, 251, 0.92)',
            background: '#ffffff'
        },
        fonts: {
            title: { family: 'Jua', weight: 'normal', size: 80 },
            caption: { family: 'Jua', weight: 'normal', size: 65 }
        },
        backgroundImage: 'https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/ssul/15.png'
    },
    ssul_16: {
        id: 'ssul_16',
        name: '썰 테마 16',
        category: 'dark',
        colors: {
            primary: '#f43f5e',
            text: '#000000',
            title1: '#ffffff',
            title2: '#000000',
            title1Bg: 'transparent',
            title2Bg: 'transparent',
            textBg: 'rgba(0, 0, 0, 0.85)',
            background: '#0a0a0a'
        },
        fonts: {
            title: { family: 'Jua', weight: 'normal', size: 80 },
            caption: { family: 'Jua', weight: 'normal', size: 65 }
        },
        backgroundImage: 'https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/ssul/16.png'
    },
    ssul_17: {
        id: 'ssul_17',
        name: '썰 테마 17',
        category: 'pastel',
        colors: {
            primary: '#b45309',
            text: '#000000',
            title1: '#ffffff',
            title2: '#000000',
            title1Bg: 'transparent',
            title2Bg: 'transparent',
            textBg: 'rgba(255, 251, 235, 0.9)',
            background: '#fffbeb'
        },
        fonts: {
            title: { family: 'Poor Story', weight: 'normal', size: 80 },
            caption: { family: 'Poor Story', weight: 'normal', size: 70 }
        },
        backgroundImage: 'https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/ssul/17.png'
    },
    ssul_18: {
        id: 'ssul_18',
        name: '썰 테마 18',
        category: 'professional',
        colors: {
            primary: '#0f172a',
            text: '#000000',
            title1: '#ffffff',
            title2: '#000000',
            title1Bg: 'transparent',
            title2Bg: 'transparent',
            textBg: 'rgba(241, 245, 249, 0.95)',
            background: '#f1f5f9'
        },
        fonts: {
            title: { family: 'Noto Sans KR', weight: 'bold', size: 80 },
            caption: { family: 'Noto Sans KR', weight: 'normal', size: 60 }
        },
        backgroundImage: 'https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/ssul/18.png'
    },
    ssul_19: {
        id: 'ssul_19',
        name: '썰 테마 19',
        category: 'vibrant',
        colors: {
            primary: '#ea580c',
            text: '#000000',
            title1: '#ffffff',
            title2: '#000000',
            title1Bg: 'transparent',
            title2Bg: 'transparent',
            textBg: 'rgba(255, 255, 255, 0.9)',
            background: '#ffffff'
        },
        fonts: {
            title: { family: 'Do Hyeon', weight: 'normal', size: 80 },
            caption: { family: 'Do Hyeon', weight: 'normal', size: 65 }
        },
        backgroundImage: 'https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/ssul/19.png'
    },
    ssul_20: {
        id: 'ssul_20',
        name: '썰 테마 20',
        category: 'dark',
        colors: {
            primary: '#064e3b',
            text: '#000000',
            title1: '#ffffff',
            title2: '#000000',
            title1Bg: 'transparent',
            title2Bg: 'transparent',
            textBg: 'rgba(255, 255, 255, 0.9)',
            background: '#ffffff'
        },
        fonts: {
            title: { family: 'Jua', weight: 'normal', size: 80 },
            caption: { family: 'Jua', weight: 'normal', size: 65 }
        },
        backgroundImage: 'https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/ssul/20.png'
    }
};

export function getThemesByCategory(category: any): any[] {
    return Object.values(TEMPLATE_THEMES).filter(theme => theme.category === category);
}

export function getThemeById(themeId: string): any {
    return TEMPLATE_THEMES[themeId];
}

export function getAllThemes(): any[] {
    return Object.values(TEMPLATE_THEMES);
}

export function getCategories(): string[] {
    return ['modern', 'minimal', 'vibrant', 'pastel', 'dark', 'professional'];
}
